/**
 * @generated SignedSource<<0b2b8d3937375e63878b3e900b4322c5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IdentityProvidersSettingsRootQuery$variables = Record<PropertyKey, never>;
export type IdentityProvidersSettingsRootQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccessControlSettingsPage_query" | "IdentityProviders_query">;
};
export type IdentityProvidersSettingsRootQuery = {
  response: IdentityProvidersSettingsRootQuery$data;
  variables: IdentityProvidersSettingsRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "idpNamespace",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "idpType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IdentityProvidersSettingsRootQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AccessControlSettingsPage_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "IdentityProviders_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IdentityProvidersSettingsRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "whoami",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          (v0/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlConfig",
            "kind": "LinkedField",
            "name": "UrlConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "docs",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SAMLProvider",
        "kind": "LinkedField",
        "name": "samlProviders",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableSignout",
            "storageKey": null
          },
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 100
          }
        ],
        "concreteType": "CloudOrganizationConnection",
        "kind": "LinkedField",
        "name": "cloudOrganizations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CloudOrganizationEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CloudOrganization",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SyncOptions",
                    "kind": "LinkedField",
                    "name": "syncOptions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "syncGroups",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "syncResourceViewerRoles",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "provider",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "cloudOrganizations(first:100)"
      }
    ]
  },
  "params": {
    "cacheID": "8d82ad9cbab074e62b81b414be5e7333",
    "id": null,
    "metadata": {},
    "name": "IdentityProvidersSettingsRootQuery",
    "operationKind": "query",
    "text": "query IdentityProvidersSettingsRootQuery {\n  ...AccessControlSettingsPage_query\n  ...IdentityProviders_query\n}\n\nfragment AccessControlSettingsPage_query on Query {\n  ...PageWithBreadCrumbs_query\n}\n\nfragment BreadCrumbsHeader_query on Query {\n  whoami {\n    email\n    displayName\n  }\n}\n\nfragment CloudOrganizationCard_organization on CloudOrganization {\n  idpNamespace\n  idpType\n  key\n  name\n  provider\n  syncOptions {\n    syncGroups\n    syncResourceViewerRoles\n  }\n}\n\nfragment IdentityProviders_query on Query {\n  samlProviders {\n    id\n    ...SamlProviderCard_provider\n  }\n  cloudOrganizations(first: 100) {\n    edges {\n      node {\n        id\n        syncOptions {\n          syncGroups\n          syncResourceViewerRoles\n        }\n        ...CloudOrganizationCard_organization\n      }\n    }\n  }\n}\n\nfragment PageWithBreadCrumbs_query on Query {\n  ...BreadCrumbsHeader_query\n}\n\nfragment SamlProviderCard_provider on SAMLProvider {\n  displayName\n  enableSignout\n  idpNamespace\n  idpType\n  name\n}\n"
  }
};
})();

(node as any).hash = "c3a62d0401aca24c6767f47adcb8edf0";

export default node;
